// let, not const - so we can change them in runtime
export let API_ROOT = 'http://localhost:8000'
export let GOOGLE_AUTH_ClientId = '74763751888-9v6vc6vs9abp3d3jgejv5en6d0l15f6s.apps.googleusercontent.com'
